export const translations = {
  tr: {
    brand: "İkizler Market",
    tagline_1: "Lefke & LAÜ'nün Sıcak Mahalle Marketi",
    tagline_2: "Taze meyve-sebze, kampüs atıştırmalıkları ve günlük ev ihtiyaçları dakikalar içinde kapında.",
    nav_home: "Ana Sayfa",
    nav_catalog: "Ürünler",
    nav_track: "Sipariş Takip",
    nav_contact: "İletişim",
    nav_admin: "Yönetim",
    search_placeholder: "Ürün ara... (portakal, hellim, ekmek)",
    all: "Hepsi",
    add_to_cart: "Sepete Ekle",
    added: "Sepete eklendi",
    cart: "Sepet",
    cart_empty: "Sepetiniz boş",
    cart_empty_desc: "Ürünlerimize göz atın ve sepetinize ekleyin.",
    subtotal: "Ara Toplam",
    delivery_fee: "Teslimat Ücreti",
    total: "Toplam",
    free: "Ücretsiz",
    checkout: "Siparişi Tamamla",
    continue_shopping: "Alışverişe Devam Et",
    remove: "Kaldır",
    stock: "Stok",
    free_delivery_note: "150₺ üzeri siparişlerde teslimat ücretsiz.",
    left_for_free_delivery: "Ücretsiz teslimat için {amount}₺ daha",
    akinsoft_synced: "Akınsoft POS Entegre - Fiyat Güncel",
    // checkout
    checkout_title: "Sipariş Bilgileri",
    customer_name: "Ad Soyad",
    phone: "Telefon (WhatsApp)",
    address: "Teslimat Adresi",
    address_placeholder: "LAÜ Kampüs / Yurt / Lefke sokak-daire",
    order_notes: "Sipariş Notu (opsiyonel)",
    payment_method: "Ödeme Yöntemi",
    cash: "Kapıda Nakit",
    card_on_delivery: "Kapıda Kredi Kartı",
    place_order: "Siparişi Onayla",
    order_success: "Siparişiniz alındı!",
    order_number: "Sipariş No",
    // track
    track_title: "Sipariş Takibi",
    track_placeholder: "Sipariş numaranızı girin (örn: IK260225-A1B2C)",
    track_btn: "Sorgula",
    status_received: "Sipariş Alındı",
    status_preparing: "Hazırlanıyor",
    status_on_the_way: "Kurye Yolda",
    status_delivered: "Teslim Edildi",
    status_cancelled: "İptal Edildi",
    // contact
    contact_title: "Bize Ulaşın",
    address_label: "Adres",
    address_value: "Lefke Avrupa Üniversitesi Ana Giriş Karşısı, Lefke / KKTC",
    hours_label: "Çalışma Saatleri",
    hours_value: "Her Gün: 07:30 - 23:30",
    phone_label: "Telefon",
    whatsapp: "WhatsApp Sipariş",
    // admin
    admin_login: "Google ile Giriş Yap",
    admin_login_note: "Yalnızca yetkili yönetici e-postası erişebilir.",
    admin_dashboard: "Yönetim Paneli",
    logout: "Çıkış",
    orders: "Siparişler",
    products: "Ürünler",
    categories: "Kategoriler",
    add_product: "Ürün Ekle",
    edit: "Düzenle",
    delete: "Sil",
    save: "Kaydet",
    cancel: "İptal",
    status: "Durum",
    name_tr: "İsim (TR)",
    name_en: "İsim (EN)",
    price: "Fiyat",
    unit: "Birim",
    category: "Kategori",
    image_url: "Görsel URL",
    akinsoft_code: "Akınsoft Kodu",
    featured: "Öne Çıkar",
    description: "Açıklama",
    unauthorized_email: "Bu e-posta ile yönetim paneline erişim yok.",
    quantity: "Adet",
    view_details: "Detayları Gör",
    close: "Kapat",
    hero_cta_primary: "Ürünleri İncele",
    hero_cta_secondary: "WhatsApp'tan Sipariş",
    campus_delivery_badge: "LAÜ Kampüs Ekspres Teslimat",
    welcome_title: "HOŞ GELDİNİZ",
    welcome_subtitle: "İkizler Market Lefke",
    featured_title: "Öne Çıkan Ürünler",
    all_products: "Tüm Ürünler",
    no_products: "Bu kategoride ürün bulunamadı.",
    order_placed_message: "Siparişiniz alındı. Kısa süre içinde sizinle iletişime geçeceğiz.",
    copy: "Kopyala",
    copied: "Kopyalandı",
    campaigns: "Kampanyalar",
    weekly_deals: "Haftanın İndirimleri",
    campaigns_title: "Kampanyalı & Haftanın İndirimli Ürünleri",
    old_price: "Eski fiyat",
    save_amount: "Kazan",
    profile_title: "Bilgileriniz",
    profile_desc: "Sipariş için ad, soyad ve açık adresinizi kaydedin. Tarayıcınızda saklanır.",
    first_name: "Ad",
    last_name: "Soyad",
    neighborhood: "Mahalle",
    street: "Sokak",
    building: "Apartman Adı",
    floor: "Kat",
    apt: "Daire No",
    save_profile: "Bilgilerimi Kaydet",
    send_location: "Kuryenin binayı kolay bulması için Anlık Konumumu Gönder",
    location_sent: "Konum eklendi",
    location_error: "Konum alınamadı",
    min_order_warning: "Minimum sepet tutarı ₺{min}. Sepetinize ₺{remaining} daha ekleyin.",
    store_closed: "Market şu an kapalı",
    store_closed_desc: "Çalışma saatlerimiz {open}:00 - {close}:00 arasıdır. Sepetiniz kaydedildi, saatler içinde sipariş verebilirsiniz.",
    delivery_closed: "Paket servis şu an kapalı",
    delivery_closed_desc: "Paket servis saatleri {start}:00 - {end}:00 arasıdır.",
    order_sent_wa: "Sipariş WhatsApp'a iletildi",
    open_whatsapp: "WhatsApp'ı Aç",
    announcements: "Duyurular",
    rules: "Kurallar",
    settings: "Ayarlar",
    couriers: "Kuryeler",
    reports: "Gün Sonu / Mutabakat",
    close_day: "Hesap Kapatma",
    import_excel: "Excel/CSV İçe Aktar",
    imported: "içe aktarıldı",
    assign_courier: "Kurye Ata",
    unassigned: "Atanmamış",
    add: "Ekle",
    packages: "Paket",
    cash_collected: "Nakit",
    card_collected: "Kredi Kartı",
    daily_total: "Günlük Toplam",
    delivered_only: "Sadece teslim edilen siparişler sayılır.",
    // Delivery fee
    free_delivery_active: "🎉 Ücretsiz servis aktif — sepetiniz eşiği geçti!",
    fee_bar_default: "₺{min} altı siparişlere ₺{fee} servis ücreti — üstü ÜCRETSİZ",
    fee_bar_active: "Servis ücreti aktif (₺{fee}). ₺{remaining} daha ekle → ÜCRETSİZ SERVİS",
    free_delivery_note_dynamic: "₺{min} ve üzeri siparişlerde servis ücretsiz",
    free_delivery_progress: "Ücretsiz servis için ₺{remaining} daha ekleyin",
    service_fee_notice: "Sepetiniz ₺{min} altında olduğu için siparişinize ₺{fee} servis ücreti eklendi. ₺{remaining} daha eklerseniz ücretsiz olur.",
    // KG / weight-based products
    choose_grams: "Gram Seç",
    kg_helper: "₺{price}/kg — istediğiniz gramı seçin (min. {min} gr)",
    custom_amount: "Özel Miktar",
    kg_step_hint: "{step} gramlık adımlarla değiştirin",
    line_total: "Satır Toplamı",
    // Customer number & recognition
    returning_customer: "Daha Önce Sipariş Verdim",
    returning_customer_desc: "Müşteri numaram ile hızlı devam et",
    new_customer: "Yeni Müşteriyim",
    new_customer_desc: "Bilgilerimi kaydet ve müşteri no al",
    customer_number_label: "Müşteri Numarası",
    lookup_hint: "Müşteri numaranızı ilk siparişinizin fişinde bulabilirsiniz.",
    lookup_missing: "Müşteri numarası ve telefon gerekli",
    lookup_failed: "Müşteri bulunamadı. Bilgileri kontrol edin.",
    welcome_back: "Hoş geldiniz {name} 👋",
    new_customer_hint: "İlk siparişinizi verdiğinizde size özel bir müşteri numarası atanacak.",
    continue: "Devam Et",
    back: "Geri",
    confirm_address_title: "Bu adrese teslimat istiyorum",
    confirm_address_desc: "Yanlış adrese gitmemek için lütfen adresinizi onaylayın. Farklı bir adres kullanacaksanız 'Düzenle' ile değiştirin.",
    please_confirm_address: "Lütfen teslimat adresinizi onaylayın",
    customer_number_note: "🎯 Bu numarayı not alın! Sonraki siparişlerinizi tek dokunuşla, bilgilerinizi tekrar yazmadan verebilirsiniz. Siparişlerinizi takip etmek için de bu numarayı kullanacaksınız.",
    address_label_home: "Ev",
    address_label_work: "İş",
    address_label_dorm: "Yurt",
    address_label_other: "Diğer",
    customers: "Müşteriler",
    total_spent: "Toplam Harcama",
    order_count: "Sipariş Sayısı",
    last_order: "Son Sipariş",
    discount_requests: "İndirim Talepleri",
    raffles: "Çekilişler",
    // Instagram discount
    ig_home_badge: "%10 Instagram İndirimi",
    ig_home_title: "Instagram'da bizi takip et — %10 indirim kazan!",
    ig_home_desc: "Sayfamızı takip et, son gönderiye 3 arkadaşını etiketle, bir sonraki siparişinde %10 indirim kazan. Her müşteri numarasına bir kez.",
    ig_home_step1: "Instagram'da bizi takip et",
    ig_home_step2: "Son gönderiye 3 arkadaşını etiketle",
    ig_home_step3: "Ödeme adımında talebini gönder → yönetici onaylayınca bir sonraki siparişinde indirim otomatik uygulanır",
    ig_home_note: "Şeffaflık: Bir yönetici Instagram'da takip + etiketleri doğrular. Onay verildikten sonra %10 indirim müşteri numaranıza tanımlanır ve bir sonraki siparişinizde otomatik uygulanır. Aynı müşteri numarasına yalnızca 1 kez indirim tanımlanır.",
    ig_home_cta: "Instagram'a Git",
    ig_discount_title: "Instagram İndirimi (%10)",
    ig_discount_desc: "3 basit adımla bir sonraki siparişine %10 indirim kazan.",
    ig_discount_line: "Instagram İndirimi (%10)",
    ig_step1_label: "Adım 1",
    ig_step1_desc: "Instagram sayfamızı aç ve takip et: @ikizlermarketlefke",
    ig_step1_action: "Instagram'a Git",
    ig_step2_label: "Adım 2",
    ig_step2_desc: "Sayfamızın en son gönderisine gir ve 3 arkadaşını yorum olarak etiketle (örn: @ali @veli @mehmet).",
    ig_step2_action: "Gönderiye Git",
    ig_step3_label: "Adım 3",
    ig_step3_desc: "Instagram kullanıcı adını gir; yönetici takibini + etiketlemeni doğrulayınca %10 indirim müşteri hesabına tanımlanacak ve bir sonraki siparişinde otomatik uygulanacak.",
    ig_username_label: "Instagram Kullanıcı Adı",
    ig_username_hint: "@ işaretini eklemene gerek yok",
    ig_username_required: "Kullanıcı adı girmen gerekli",
    ig_need_customer: "Önce sipariş verip müşteri numaran oluşmalı",
    ig_submit_btn: "Talebi Gönder",
    ig_request_success: "Talebin alındı! Yönetici uygun bir zamanda doğrulayacak.",
    ig_request_failed: "Talep gönderilemedi",
    ig_success_title: "Talebin bize ulaştı 🎉",
    ig_success_desc: "Yönetici Instagram'daki takip ve etiketlerini kontrol edip onay verecek. Onaylandığında bir sonraki siparişinde %10 indirim otomatik uygulanır.",
    ig_success_note: "Not: Onay her zaman anında olamayabilir — uygun bir zamanda değerlendirilir. Sabrın için teşekkürler!",
    ig_status_used: "Instagram indirimini kullandın. Teşekkürler!",
    ig_status_ready: "🎁 Bir sonraki siparişinde %10 indirim otomatik uygulanacak!",
    ig_status_applied: "🎁 Bu siparişinde %10 indirim uygulandı!",
    ig_status_pending: "Instagram talebin inceleniyor — bir sonraki siparişinde uygulanabilir.",
    ig_cta_title: "Instagram İndirimi Kazan (%10)",
    ig_cta_desc: "Takip et + 3 arkadaş etiketle → bir sonraki sipariş",
  },
  en: {
    brand: "İkizler Market",
    tagline_1: "The Warm Neighborhood Market of Lefke & EUL",
    tagline_2: "Fresh produce, campus snacks and daily home essentials at your door in minutes.",
    nav_home: "Home",
    nav_catalog: "Products",
    nav_track: "Track Order",
    nav_contact: "Contact",
    nav_admin: "Admin",
    search_placeholder: "Search products... (orange, halloumi, bread)",
    all: "All",
    add_to_cart: "Add to Cart",
    added: "Added to cart",
    cart: "Cart",
    cart_empty: "Your cart is empty",
    cart_empty_desc: "Browse our products and add them to your cart.",
    subtotal: "Subtotal",
    delivery_fee: "Delivery Fee",
    total: "Total",
    free: "Free",
    checkout: "Checkout",
    continue_shopping: "Continue Shopping",
    remove: "Remove",
    stock: "Stock",
    free_delivery_note: "Free delivery for orders above ₺150.",
    left_for_free_delivery: "₺{amount} more for free delivery",
    akinsoft_synced: "Akınsoft POS Integrated - Price Live",
    checkout_title: "Order Details",
    customer_name: "Full Name",
    phone: "Phone (WhatsApp)",
    address: "Delivery Address",
    address_placeholder: "EUL Campus / Dorm / Lefke street-apartment",
    order_notes: "Order Notes (optional)",
    payment_method: "Payment Method",
    cash: "Cash on Delivery",
    card_on_delivery: "Card on Delivery",
    place_order: "Place Order",
    order_success: "Your order has been placed!",
    order_number: "Order No",
    track_title: "Track Order",
    track_placeholder: "Enter your order number (e.g. IK260225-A1B2C)",
    track_btn: "Track",
    status_received: "Order Received",
    status_preparing: "Preparing",
    status_on_the_way: "Courier On The Way",
    status_delivered: "Delivered",
    status_cancelled: "Cancelled",
    contact_title: "Contact Us",
    address_label: "Address",
    address_value: "Opposite EUL Main Gate, Lefke / TRNC",
    hours_label: "Working Hours",
    hours_value: "Every Day: 07:30 - 23:30",
    phone_label: "Phone",
    whatsapp: "WhatsApp Order",
    admin_login: "Sign in with Google",
    admin_login_note: "Only the authorized admin email can access.",
    admin_dashboard: "Admin Dashboard",
    logout: "Logout",
    orders: "Orders",
    products: "Products",
    categories: "Categories",
    add_product: "Add Product",
    edit: "Edit",
    delete: "Delete",
    save: "Save",
    cancel: "Cancel",
    status: "Status",
    name_tr: "Name (TR)",
    name_en: "Name (EN)",
    price: "Price",
    unit: "Unit",
    category: "Category",
    image_url: "Image URL",
    akinsoft_code: "Akınsoft Code",
    featured: "Featured",
    description: "Description",
    unauthorized_email: "This email is not authorized to access admin panel.",
    quantity: "Qty",
    view_details: "View Details",
    close: "Close",
    hero_cta_primary: "Browse Products",
    hero_cta_secondary: "Order via WhatsApp",
    campus_delivery_badge: "EUL Campus Express Delivery",
    featured_title: "Featured Products",
    all_products: "All Products",
    no_products: "No products found in this category.",
    order_placed_message: "Your order has been received. We will contact you shortly.",
    copy: "Copy",
    copied: "Copied",
    campaigns: "Deals",
    weekly_deals: "Weekly Deals",
    campaigns_title: "Campaigns & Weekly Deals",
    old_price: "Was",
    save_amount: "Save",
    profile_title: "Your Details",
    profile_desc: "Save your name and full address for faster orders. Stored on your browser.",
    first_name: "First name",
    last_name: "Last name",
    neighborhood: "Neighborhood",
    street: "Street",
    building: "Building",
    floor: "Floor",
    apt: "Apt No",
    save_profile: "Save My Info",
    send_location: "Share my live location so the courier finds the building easily",
    location_sent: "Location added",
    location_error: "Could not get location",
    min_order_warning: "Minimum order ₺{min}. Add ₺{remaining} more to place an order.",
    store_closed: "Store is currently closed",
    store_closed_desc: "Working hours are {open}:00 - {close}:00. Your cart is saved.",
    delivery_closed: "Delivery is currently closed",
    delivery_closed_desc: "Delivery hours are {start}:00 - {end}:00.",
    order_sent_wa: "Order sent to WhatsApp",
    open_whatsapp: "Open WhatsApp",
    announcements: "Announcements",
    rules: "Rules",
    settings: "Settings",
    couriers: "Couriers",
    reports: "End of Day",
    close_day: "Close Day",
    import_excel: "Import Excel/CSV",
    imported: "imported",
    assign_courier: "Assign Courier",
    unassigned: "Unassigned",
    add: "Add",
    packages: "Pkgs",
    cash_collected: "Cash",
    card_collected: "Card",
    daily_total: "Daily Total",
    delivered_only: "Only delivered orders are counted.",
    free_delivery_active: "🎉 Free delivery unlocked!",
    fee_bar_default: "Orders under ₺{min} carry a ₺{fee} service fee — above is FREE",
    fee_bar_active: "Service fee applied (₺{fee}). Add ₺{remaining} → FREE DELIVERY",
    free_delivery_note_dynamic: "Free delivery on orders ₺{min}+",
    free_delivery_progress: "Add ₺{remaining} more for free delivery",
    service_fee_notice: "Your cart is under ₺{min}, so a ₺{fee} service fee was added. Add ₺{remaining} more to make it free.",
    choose_grams: "Choose Grams",
    kg_helper: "₺{price}/kg — pick your amount (min {min} gr)",
    custom_amount: "Custom Amount",
    kg_step_hint: "Adjust in {step}-gram steps",
    line_total: "Line Total",
    returning_customer: "I've Ordered Before",
    returning_customer_desc: "Continue with my customer number",
    new_customer: "New Customer",
    new_customer_desc: "Save my info and get a customer number",
    customer_number_label: "Customer Number",
    lookup_hint: "You can find your customer number on your first order receipt.",
    lookup_missing: "Customer number and phone required",
    lookup_failed: "Customer not found. Check details.",
    welcome_back: "Welcome back {name} 👋",
    new_customer_hint: "You'll receive a unique customer number after your first order.",
    continue: "Continue",
    back: "Back",
    confirm_address_title: "Deliver to this address",
    confirm_address_desc: "Please confirm your delivery address to avoid wrong deliveries. Tap 'Edit' if you need to change it.",
    please_confirm_address: "Please confirm your delivery address",
    customer_number_note: "🎯 Save this number! On future orders you can skip typing your details and track orders faster.",
    customers: "Customers",
    total_spent: "Total Spent",
    order_count: "Orders",
    last_order: "Last Order",
    discount_requests: "Discount Requests",
    raffles: "Raffles",
    ig_home_badge: "10% Instagram Discount",
    ig_home_title: "Follow us on Instagram — win 10% off!",
    ig_home_desc: "Follow our page, tag 3 friends on the latest post, get 10% off your next order. Once per customer number.",
    ig_home_step1: "Follow us on Instagram",
    ig_home_step2: "Tag 3 friends on the latest post",
    ig_home_step3: "Submit your request at checkout — the admin approves and 10% is applied on your next order",
    ig_home_note: "Transparency: an admin verifies your follow + tags. Once approved, 10% is linked to your customer number and auto-applied on your next order. Only one discount per customer number.",
    ig_home_cta: "Open Instagram",
    ig_discount_title: "Instagram Discount (10%)",
    ig_discount_desc: "3 simple steps to earn 10% off your next order.",
    ig_discount_line: "Instagram Discount (10%)",
    ig_step1_label: "Step 1",
    ig_step1_desc: "Open our Instagram and follow us: @ikizlermarketlefke",
    ig_step1_action: "Open Instagram",
    ig_step2_label: "Step 2",
    ig_step2_desc: "Go to our latest post and tag 3 friends in the comments (e.g. @alice @bob @carol).",
    ig_step2_action: "Open Post",
    ig_step3_label: "Step 3",
    ig_step3_desc: "Enter your Instagram username; the admin verifies and 10% is auto-applied on your next order.",
    ig_username_label: "Instagram Username",
    ig_username_hint: "No need to add the @",
    ig_username_required: "Username is required",
    ig_need_customer: "Place an order first to receive a customer number",
    ig_submit_btn: "Submit Request",
    ig_request_success: "Request received! Admin will review shortly.",
    ig_request_failed: "Could not submit request",
    ig_success_title: "Request received 🎉",
    ig_success_desc: "Admin will verify your follow + tags. Once approved, 10% will be auto-applied on your next order.",
    ig_success_note: "Note: approval may take some time. Thanks for your patience!",
    ig_status_used: "You've used your Instagram discount. Thanks!",
    ig_status_ready: "🎁 10% will be auto-applied on your next order!",
    ig_status_applied: "🎁 10% discount is applied on this order!",
    ig_status_pending: "Your Instagram request is being reviewed.",
    ig_cta_title: "Win 10% Instagram Discount",
    ig_cta_desc: "Follow + tag 3 friends → next order",
  },
};
